import { FormField, getErrors, Select } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type SelectFieldProps = {
  moreInfo?: string;
  items: ComponentProps<typeof Select>['items'];
  placeholder?: ComponentProps<typeof Select>['placeholder'];
  defaultValue?: ComponentProps<typeof Select>['defaultSelectedKey'];
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function SelectField(props: SelectFieldProps) {
  const { items, placeholder, defaultValue, ...rest } = props;
  const field = useFieldContext<string>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={
        <Select
          enforceMaxHeight
          items={items}
          placeholder={placeholder}
          defaultSelectedKey={defaultValue}
          value={field.state.value}
          onChange={(value) => field.handleChange(value.toString())}
        />
      }
    />
  );
}
